module.exports = __webpack_public_path__ + "img/coupons_icon_expired_tw.9255bdd3.png";